import { render, staticRenderFns } from "./MessageHTMLBody.vue?vue&type=template&id=7701c524&scoped=true"
import script from "./MessageHTMLBody.vue?vue&type=script&lang=js"
export * from "./MessageHTMLBody.vue?vue&type=script&lang=js"
import style0 from "./MessageHTMLBody.vue?vue&type=style&index=0&id=7701c524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7701c524",
  null
  
)

export default component.exports